import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Packages from "@/components/Packages";
import Upsells from "@/components/Upsells";
import SubscriberPlanning from "@/components/SubscriberPlanning";
import Gallery from "@/components/Gallery";
import FAQ from "@/components/FAQ";
import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Landing() {
    return (
        <>
            <SEO
                title="Studio Podcast Villiers-sur-Marne · Paris Est — RER A & E · Studio Mon Séraphin"
                description="Studio podcast clé-en-main à Villiers-sur-Marne (Paris Est) : enregistrement audio & vidéo, montage, shorts, stratégie. RER A Noisy-le-Grand · RER E Villiers-sur-Marne. Pour Paris et toute l'Île-de-France. Ouvert 7j/7, à partir de 90€."
                path="/"
                keywords="studio podcast, studio podcast Paris, studio podcast Paris Est, studio podcast Villiers-sur-Marne, studio podcast Noisy-le-Grand, studio podcast RER A, studio podcast RER E, studio podcast Île-de-France, location studio podcast, enregistrement podcast Paris, podcast clé en main, podcast vidéo, montage podcast, studio podcast Bry-sur-Marne, studio podcast Champigny-sur-Marne, studio podcast Torcy"
            />
            <Navbar />
            <main className="relative">
                <Hero />
                <About />
                <Gallery />
                <Packages />
                <SubscriberPlanning />
                <Upsells />

                {/* CTA band */}
                <section className="relative py-20 px-6 md:px-12" data-testid="cta-band">
                    <div className="relative max-w-5xl mx-auto rounded-xl border border-white/10 bg-white/[0.02] p-10 md:p-14">
                        <div className="grid md:grid-cols-[1fr_auto] gap-8 items-center">
                            <div>
                                <h3 className="font-display text-3xl md:text-4xl font-light tracking-tight text-white">
                                    Prêt·e à enregistrer votre premier épisode ?
                                </h3>
                                <p className="mt-3 text-zinc-400 font-body max-w-lg">
                                    Réservez en ligne en moins de 2 minutes. Paiement à votre rythme.
                                </p>
                            </div>
                            <Link
                                to="/reserver"
                                className="group inline-flex items-center justify-center gap-2 rounded-md bg-amber-300 px-6 py-3 text-sm font-medium text-zinc-950 hover:bg-amber-200 transition-colors"
                                data-testid="cta-reserver-btn"
                            >
                                Réserver maintenant
                                <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
                            </Link>
                        </div>
                    </div>
                </section>

                <FAQ />
            </main>
            <Footer />
        </>
    );
}
